import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import useTokenStore from "../Store/Store";
import Prev from "../../img/PrevBlack.png"
import DeleteImg from "../../img/Delete.png"
import NaverImg from "../../img/naver.png"
import TossImg from "../../img/toss.png"
import KakaoImg from "../../img/kakao.png"
import { useParams } from "react-router-dom"; // 라우터를 쓰고 있다면
import LoadingImg from "../../img/Loading.png"


import axios from "axios";
import { useCookies } from 'react-cookie';
import CompanyInfo from "../MenuCompo/CompanyInfo";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
        background-color:#ffffff;
    `,
    PayCheckingWrap:styled.div`
        width:88.8%;
        height:202px;
        margin-top:180px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        flex-direction:column;
    `,
        PayCheckImgBox:styled.div`
            width:120px;
            height:120px;
        `,
            PayCheckImg:styled.img`
                width:100%;
                height:100%;
            `,
        PayCheckTextWrap:styled.div`
            width:100%;
            height:70px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:column;
        `,
            PayCheckTitle:styled.p`
                font-size:20px;
                font-weight:600;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
            PayCheckText:styled.p`
                font-size:14px;
                font-weight:600;
                color:#767676;
                margin:0px;
                font-family:'PreFont';
            `,
    HeaderWrap:styled.div`
        width:100%;
        height:56px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        position:fixed;
        z-index:3;
        background-color:#ffffff;
    `,
        Header:styled.div`
            width:90%;
            height:56px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
            HeaderText:styled.p`
                font-size:20px;
                font-weight:600;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
        Nothing:styled.div`
            width:100%;
            height:56px;
        `,
        ContentWrap:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:column;
        `,
        EmptyContents:styled.div`
            width:100%;
            height: calc(100vh - 156px);
            display:flex;
            justify-content:center;
            align-items:center;
            flex-direction:column;
        `,
            EmptyText:styled.p`
                font-size:16px;
                font-weight:600;
                color:#919191;
                margin:0px;
                font-family:'PreFont';
            `,
            ContentBox:styled.div`
                width:100%;
                height:auto;
                padding:10px 0px 20px 0px;
                display:flex;
                justify-content:space-between;
                align-items:flex-start;
                flex-direction:row;
            `,
                ContentImg:styled.img`
                    width:25%;
                    height:46%;
                    border-radius:10px;
                `,
                ContentOptionBox:styled.div`
                    width:59%;
                    height:auto;
                    display:flex;
                    justify-content:space-between;
                    align-items:flex-start;
                    flex-direction:column;
                `,
                    NamePrice:styled.p`
                        font-size:16px;
                        font-weight:600;
                        color:#181818;
                        margin:0px;
                        font-family:'PreFont';
                    `,
                    Onegai:styled.p`
                        font-size:14px;
                        font-weight:400;
                        color:#929292;
                        margin:0px;
                        font-family:'PreFont';
                    `,
                    BtnWrap:styled.div`
                        width:100%;
                        height:28px;
                        display:flex;
                        justify-content:space-between;
                        align-items:center;
                        flex-direction:row;
                    `,
                        OptionBtn:styled.div`
                            width:104px;
                            height:28px;
                            border-radius:6px;
                            border:1px solid #B5B5B5;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                        `,
                            OptionBtnText:styled.p`
                                font-size:14px;
                                font-weight:400;
                                color:#5F5F5F;
                                margin:0px;
                                font-family:'PreFont';
                            `,
                        NumberBtnWrap:styled.div`
                            width:68px;
                            height:20px;
                            display:flex;
                            justify-content:space-between;
                            align-items:center;
                            flex-direction:row;
                        `,
                            NumberText:styled.p`
                                font-size:16px;
                                font-weight:600;
                                color:#181818;
                                margin:0px;
                                font-family:'PreFont';
                            `,
                    ContentBar:styled.div`
                        width:100%;
                        height:1px;
                        background-color:#eeeeee;
                    `,
                DeleteBtn:styled.div`
                    width:20px;
                    height:20px;
                    background-image: url(${DeleteImg});
                `,
                Bar:styled.div`
                    width:100%;
                    height:10px;
                    background-color:#F5F5F5;
                `,
                PrcieWrap:styled.div`
                    width:100%;
                    height:111px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                `,
                    PrcieBorderBox:styled.div`
                        width:90%;
                        height:71px;
                        border-radius:13px;
                        border:1px solid #B4B4B4;
                        display:flex;
                        justify-content:center;
                        align-items:center;
                        flex-direction:row;
                    `,
                        PriceBox:styled.div`
                            width:90%;
                            height:20px;
                            display:flex;
                            justify-content:space-between;
                            align-items:center;
                            flex-direction:row;
                        `,
                            PrcieText:styled.p`
                                font-size:16px;
                                font-weight:600;
                                color:#000000;
                                margin:0px;
                                font-family:'PreFont';
                            `,

        PaymentsWrap:styled.div`
            width:90%;
            height:328px;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:column;
        `,
            PaymentTitleBox:styled.div`
                width:100%;
                height:48px;
                display:flex;
                justify-content:flex-start;
                align-items:center;
                flex-direction:row;
            `,
                PaymentTitle:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color:#000000;
                    margin:0px;
                    font-family:'PreFont';
                `,
            PaymentsChoiceWrap:styled.div`
                width:100%;
                height:260px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
                flex-wrap:wrap;
            `,
                PaymentsChoiceBox:styled.div`
                    width:48.4%;
                    height:80px;
                    border-radius:10px;
                    border:1px solid #D8D8D8;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                `,
                    PaymentsImg:styled.img`
                        width:auto;
                        height:auto;
                    `,
                    PaymentsText:styled.p`
                        font-size:14px;
                        font-weight:400;
                        color:#767676;
                        margin:0px;
                        font-family:'PreFont';
                    `,



                FooterNothing:styled.div`
                    width:100%;
                    height:140px;
                `,
        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            background-color:#ffffff;
            z-index:3;
            position:fixed;
            bottom:0;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,


            EmptyContents:styled.div`
                width:100%;
                height: calc(100vh - 156px);
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
            `,
                EmptyText:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color:#919191;
                    margin:0px;
                    font-family:'PreFont';
                `,

}
const Cart=()=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const [IDcookies, setIDcookies, removeIDcookies] = useCookies(["restaurant_id"]);
    const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
    const [Table_PK, setTable_PK] = useState(undefined)
    const [CartApiData, setCartApiData] = useState([])
    const [Nums, setNums] = useState([])
    const [PayChoice, setPayChoice] = useState(true)
    const [CartCookieData, setCartCookieData] = useState(undefined)
    const [RSPData, setRSPData] = useState(undefined)

    const { uuid } = useParams();

    // 카드사를 선택하면 true로 바뀌는 구조였는데
    // 우리가 카드사를 선택할 수 없음. KG이니시스로 가서 카드사를 선택하는 구조라 true로 고정
    // 차후에 PG사를 창업하거나, VAN 서비스까지 가능하면 활성화될듯.
    const CallBtn=styled.div`
        width:90%;
        height:50px;
        border-radius:10px;
        background-color:${PayChoice === false ? "#999999":"#2277F6"};
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:row;
        margin-top:10px;
    `;


    const navigate = useNavigate();
    const {
        Pocket,
        setPocket,
    } = useTokenStore()

    useEffect(()=>{
        if(Pocket.length === 0){
            setPayChoice(false)
        }
    }, [Pocket])


    const sortSelections = (data) => {
        return data.map(item => ({
          ...item,
          selected_options: Array.isArray(item.selected_options)
            ? item.selected_options
                .filter(opt => opt && typeof opt === "object") // null이나 비객체 제거
                .map(opt => Object.fromEntries(Object.entries(opt).sort()))
            : [],
          selected_additional: Array.isArray(item.selected_additional)
            ? item.selected_additional
                .filter(add => add && typeof add === "object")
                .map(add => Object.fromEntries(Object.entries(add).sort()))
            : [],
        }));
      };

    const [ReactUuid, setReactUuid]=useState(undefined)
    useEffect(()=>{
        const saved_uuid_data = JSON.parse(localStorage.getItem("uuid_data"));
        setReactUuid(saved_uuid_data)
    },[])

    useEffect(() => {
        if (Pocket.length > 0 && Nums.length === 0) {
            const nums = Pocket.map(v => v[0].Num);
            const prices = Pocket.map(v => v[0].Price);
            setNums(nums);
            setPriceArr(prices);
        }
    
        const savedRaw = localStorage.getItem("cart_data");
        const saved = savedRaw ? sortSelections(JSON.parse(savedRaw)) : [];
        setCartCookieData(saved);
        console.log(saved)
    }, [Pocket]);


    useEffect(() => {
        if (Pocket.length === 0 || Nums.length === 0) return;
    
        const result = Pocket.map((item, idx) => ({
            menu: item[0].Id,
            quantity: Nums[idx],
            selected_options: item[0].Azi === undefined ? [] : [item[0].Azi],
            selected_additional: item[0].Additional ?? [],
        }));
        setCartApiData(result);
    }, [Nums, Pocket]);

    useEffect(()=>{
        console.log(CartApiData)
    },[CartApiData])
    

    const [PriceArr, setPriceArr] = useState([])
    const [AllPrice, setAllPrice] = useState(undefined)
    useEffect(() => {
        setNums(Pocket.map(v => v[0].Num));
        setPriceArr(Pocket.map(v=>v[0].Price))
    }, [Pocket]);


    function Calculation() {
        const totalPrice = Pocket.reduce((acc, cur, idx) => {
            const menu = cur[0];  // 메뉴 항목
            const quantity = Nums[idx] ?? 1;
    
            const basePrice = menu.Price ?? 0;
    
            // 옵션 가격 (azi): 하나만 존재한다고 가정
            const optionPrice = menu.Azi
                ? parseInt(Object.values(menu.Azi)[0], 10)
                : 0;
    
            // 추가메뉴 가격 총합 (Additional): 여러 개
            const additionsPrice = Array.isArray(menu.Additional)
                ? menu.Additional.reduce((sum, item) => {
                    const value = parseInt(Object.values(item)[0], 10);
                    return sum + (isNaN(value) ? 0 : value);
                }, 0)
                : 0;
    
            const totalMenuPrice = (basePrice + optionPrice + additionsPrice)  * quantity;
    
            return acc + totalMenuPrice;
        }, 0);
    
        setAllPrice(totalPrice);
    }
    useEffect(() => {
        // 각 상품의 가격을 수량과 곱하여 모두 더한 값 계산
        Calculation()
    }, [Nums]);

    const handleIncrement = (idx) => {
        setNums(prevNums => {
            const updatedNums = [...prevNums];
            updatedNums[idx]++;
            return updatedNums;
        });
    };

    const handleMinus = (idx) => {
        setNums(prevNums => {
            const updatedNums = [...prevNums];
            // 수량이 0보다 작아지지 않도록 조건 추가
            if (updatedNums[idx] > 1) {
                updatedNums[idx]--;
            }else{
                alert("주문 수량은 1보다 작아질 수 없습니다. 우측 상단의 x버튼을 눌러주세요")
            }
            return updatedNums;
        });
    };
    function addCommasEveryThirdDigit(number) {
        if (typeof number !== 'undefined') {
            return number.toLocaleString('en-US');
        } else {
            // number가 유효하지 않을 때 처리
            return "";
        }
    }

    const handleDelete = (idx) => {
        const updatedPocket = [...Pocket];  // 상태 복사
        updatedPocket.splice(idx, 1);  // 해당 인덱스의 아이템을 삭제
        setPocket(updatedPocket);  // 상태 업데이트
        Calculation();  // 가격 계산
    };


    const axiosInstance = axios.create({
        baseURL: 'https://zzikgomainapi.co.kr/',
    });

    useEffect(() => {
        if (Pocket.length !== 0) {
          const updated = Pocket.map(group =>
            group.map(item => {
              let totalPrice = item.Price;
      
              // Azi 가격 추가
              if (item.Azi) {
                for (const key in item.Azi) {
                  const value = parseInt(item.Azi[key], 10);
                  if (!isNaN(value)) {
                    totalPrice += value;
                  }
                }
              }
      
              // Additional 가격 추가
              if (Array.isArray(item.Additional)) {
                item.Additional.forEach(add => {
                  for (const key in add) {
                    const value = parseInt(add[key], 10);
                    if (!isNaN(value)) {
                      totalPrice += value;
                    }
                  }
                });
              }
      
              return {
                ...item,
                FinalPrice: totalPrice
              };
            })
          );
        }
      }, [Pocket]);
    

    const handlePayment = () => {
        if (PayChoice === true) {
            if (!window.IMP) return alert("포트원 SDK 로드 실패");
    
            const currentNums = [...Nums]; // 상태 대신 최신값 직접 계산
            const cartData = Pocket.map((item, idx) => ({
                menu: item[0].Id,
                quantity: currentNums[idx],
                selected_options: item[0].Azi === undefined ? [] : [item[0].Azi],
                selected_additional: item[0].Additional ?? [],
            }));
    
            localStorage.setItem("nums_data", JSON.stringify(Nums));
            localStorage.setItem("cart_data", JSON.stringify(cartData));
            localStorage.setItem("pocket_data", JSON.stringify(Pocket));
    
            window.IMP.init("imp81138523");
    
            window.IMP.request_pay(
                {
                    pg: "html5_inicis",
                    channelKey: "channel-key-c6508b05-cf29-479b-8a47-791580bb77a0",
                    notice_url: `https://zzikgo.netlify.app/cart/${ReactUuid}/`,
                    pay_method: "card",
                    merchant_uid: `order_${new Date().getTime()}`,
                    name: Pocket.length === 0 ? Pocket[0][0].Name["KR"] : `${Pocket[0][0].Name["KR"]} 및 ${Pocket.length - 1}개`,
                    amount: AllPrice, // AllPrice로 변경 예정
                    buyer_email: "",
                    buyer_name: "",
                    buyer_tel: "",
                    buyer_addr: "",
                    buyer_postcode: "",
                    m_redirect_url: `https://zzikgo.netlify.app/cart/${ReactUuid}/`
                },
                (rsp) => {
                    if (rsp.success) {
                        sendPaymentInfo(rsp);
                    } else {
                        alert(`결제 실패: ${rsp.error_msg}`);
                    }
                }
            );
        }
    };
    
      const sendPaymentInfo = async (rsp) => {
        try {
            const response = await fetch("https://zzikgo.netlify.app/api/v1/order/payment", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                    imp_uid: rsp.imp_uid, // 결제 고유번호
                    merchant_uid: rsp.merchant_uid, // 주문번호
                    amount: rsp.paid_amount, // 결제 금액
                }),
            });
    
            if (!response.ok) throw new Error("결제 정보 저장 실패");
                const data = await response.json();
                // alert("결제가 완료되었습니다!");
                // 결제 되면 카트에서 주문내역으로 이동
            } catch (error) {
                console.error("결제 정보 저장 에러:", error);
                alert("결제 정보 저장에 실패했습니다.");
            }
        };

    useEffect(()=>{
        if(CartCookieData !== undefined && RSPData !== undefined){
            
            PayCheck()
        }
    }, [CartCookieData, RSPData])

    

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const imp_uid = query.get("imp_uid");
        
        if (imp_uid) {
            setRSPData(imp_uid)
        }
    }, []);

    const [PayChecking, setPayChecking] = useState(false)

    const PayCheck = async () => {
        setPayChecking(true)
        try {
            const response = await axiosInstance.get("orders/payment/"+RSPData+"/");
            if(response.data.response.status !== "failed"){
                CartApi() 
                setPayChecking(false)
                setPocket([])
                navigate(`/end`)
            }
            if(response.data.response.status === "failed"){
                alert("결제에 실패했어요 ㅠ.ㅠ 귀찮으시더라도 다시 담아주세요")
                navigate(`/${IDcookies["restaurant_id"]}`)
            }
        } catch (error) {
            console.error(error); // 요청에 실패한 경우 에러 메시지 출력
        }
    };

    const CartApi = async () => {
        console.log(CartCookieData)
        try {
            const response = await axiosInstance.post("orders/order/", {
                table:Table_PK,
                restaurant:Restaurant_PK,
                payment_id:RSPData,
                // items:CartApiData,
                items:CartCookieData,
            });
            localStorage.removeItem("cart_data");
        } catch (error) {
            console.error(error); // 요청에 실패한 경우 에러 메시지 출력
        }
    }
    useEffect(()=>{
        console.log(CartCookieData)
    })


    const [Title, setTitle] = useState({
        "KR":"장바구니",
        "EN":"Cart",
        "CN":"购物车",
        "JP":"カート",
        "FR":"panier",
        "SP":"carrito",
        "GR":"Warenkorb",
        "RU":"корзина"
    })
    const [OrderRequest, setOrderRequest] = useState({
        "KR":"추가메뉴",
        "EN":"Additional Menu",
        "CN":"附加菜单",
        "JP":"追加メニュー",
        "FR":"Menu supplémentaire",
        "SP":"Menú adicional",
        "GR":"Zusatzmenü",
        "RU":"Дополнительное меню"
    })
    const [LastPay, setLastPay] = useState({
        "KR":"최종결제금액",
        "EN":"final payment amount",
        "CN":"最终支付金额",
        "JP":"最終支払金額",
        "FR":"montant total",
        "SP":"importe total",
        "GR":"Gesamtbetrag",
        "RU":"итоговая сумма"
    })

    const [Won, setWon] = useState({
        "KR":"원",
        "EN":"won",
        "CN":"won",
        "JP":"ウォン",
        "FR":"won",
        "SP":"won",
        "GR":"won",
        "RU":"won"
    })

    const [None, setNone] = useState({
        "KR":"없음",
        "EN":"None",
        "CN":"None",
        "JP":"なし",
        "FR":"None",
        "SP":"None",
        "GR":"None",
        "RU":"None"
    })

    const [Option, setOption] = useState({
        "KR":"옵션",
        "EN":"option",
        "CN":"option",
        "JP":"オプション",
        "FR":"option",
        "SP":"option",
        "GR":"option",
        "RU":"option"
    })

    const [Pay, setPay] = useState({
        "KR":"결제하기",
        "EN":"Proceed to Payment",
        "CN":"支付",
        "JP":"支払い",
        "FR":"procéder au paiement",
        "SP":"pagar",
        "GR":"Bezahlen",
        "RU":"оплатить"
    })
    const [OptionChangeText, setOptionChangeText] = useState({
        "KR":"옵션변경",
        "EN":"change options",
        "CN":"选项变更",
        "JP":"オプション変更",
        "FR":"changement",
        "SP":"cambio",
        "GR":"Änderung",
        "RU":"изменение"
    }) 


    useEffect(() => {
        if (IDcookies["restaurant_id"]) {
            const first = IDcookies["restaurant_id"].substring(0, 36);     // 앞 절반
      const second = IDcookies["restaurant_id"].substring(36);       // 뒤 절반
  
      setRestaurant_PK(first);
      setTable_PK(second);
            console.log(IDcookies["restaurant_id"])
        } else {
            console.log("ID 값이 없습니다.");
        }
    }, [IDcookies["restaurant_id"]]);

    
    if(PayChecking === false){
        return(
            <Styled.Wrap>
                <Styled.HeaderWrap>
                    <Styled.Header>
                        <Styled.PrevBtn 
                            onClick={() => navigate(`/${IDcookies["restaurant_id"]}`)}
                        >
                            <Styled.PrevImg src={Prev}/>
                        </Styled.PrevBtn>
                        <Styled.HeaderText>{Title[Langcookies["PageLang"]]}</Styled.HeaderText>
                        <Styled.PrevBtn />
                    </Styled.Header>
                </Styled.HeaderWrap>
                <Styled.Nothing />
                <Styled.ContentWrap>
                    {Pocket.length === 0 ? 
                        <Styled.EmptyContents>
                            <Styled.EmptyText>장바구니가 텅 비어있어요</Styled.EmptyText>
                        </Styled.EmptyContents>
                        :<></>
                    }
                    {Pocket.map((v, idx)=>{
                        console.log(v)
                        return(
                            <>
                                <Styled.ContentBox>
                                    <Styled.ContentImg src={`https://zzikgomainapi.co.kr${v[0].Img}`}/>
                                    <Styled.ContentOptionBox>
                                        <Styled.NamePrice>{v[0].Name[Langcookies["PageLang"]]}</Styled.NamePrice>
                                        <Styled.NamePrice>{addCommasEveryThirdDigit(v[0].Price)}{Won[Langcookies["PageLang"]]}</Styled.NamePrice>
                                        {v[0].Azi === undefined ? 
                                            <Styled.Onegai>{Option[Langcookies["PageLang"]]} : {None[Langcookies["PageLang"]]}</Styled.Onegai>
                                            :
                                            <Styled.Onegai>{Option[Langcookies["PageLang"]]} : {Object.keys(v[0].Azi)} : {Object.values(v[0].Azi)}{Won[Langcookies["PageLang"]]}</Styled.Onegai>
                                        }
                                        <Styled.Onegai>{OrderRequest[Langcookies["PageLang"]]} : {v[0].Additional !==undefined && v[0].Additional.length === 0 ? "없음": v[0].Additional.length === 1? Object.keys(v[0].Additional[0]):Object.keys(v[0].Additional[0])+` 및 ${v[0].Additional.length-1}건`}</Styled.Onegai>
                                        <Styled.BtnWrap>
                                            <Styled.OptionBtn>
                                                <Styled.OptionBtnText onClick={() => 
                                                    navigate("/menuchange", { state: { someData: v, INDEX:idx } })}
                                                >
                                                    {OptionChangeText[Langcookies["PageLang"]]}
                                                </Styled.OptionBtnText>
                                            </Styled.OptionBtn>
                                            <Styled.NumberBtnWrap>
                                                <Styled.NumberText onClick={()=>{handleMinus(idx)}}>-</Styled.NumberText>
                                                <Styled.NumberText>{Nums[idx]}</Styled.NumberText>
                                                <Styled.NumberText onClick={()=>{handleIncrement(idx)}}>+</Styled.NumberText>
                                            </Styled.NumberBtnWrap>
                                        </Styled.BtnWrap>
                                    </Styled.ContentOptionBox>
                                    <Styled.DeleteBtn onClick={()=>{
                                        handleDelete(idx);
                                    }}/>
                                </Styled.ContentBox>
                                <Styled.ContentBar />
                            </>
                        )
                    })}
                </Styled.ContentWrap>
                {Pocket.length === 0 ? 
                        <></>
                        :
                        <Styled.PrcieWrap>
                            <Styled.PrcieBorderBox>
                                <Styled.PriceBox>
                                    <Styled.PrcieText>{LastPay[Langcookies["PageLang"]]}</Styled.PrcieText>
                                    <Styled.PrcieText>{addCommasEveryThirdDigit(AllPrice)}{Won[Langcookies["PageLang"]]}</Styled.PrcieText>
                                </Styled.PriceBox>
                            </Styled.PrcieBorderBox>
                            {/* <Styled.PrcieText>{AllPrice}원</Styled.PrcieText> */}
                        </Styled.PrcieWrap>
                }
                


                <CompanyInfo />
                <Styled.FooterNothing />
                <Styled.Footer>
                    <CallBtn onClick={()=>{
                        handlePayment()
                    }}>
                        <Styled.BtnText>{Pay[Langcookies["PageLang"]]}</Styled.BtnText>
                    </CallBtn>
                </Styled.Footer>
            </Styled.Wrap>
        )
    }else{
        return(
            <Styled.Wrap>
                <Styled.PayCheckingWrap>
                    <Styled.PayCheckImgBox>
                        <Styled.PayCheckImg src={LoadingImg}/>
                    </Styled.PayCheckImgBox>
                    <Styled.PayCheckTextWrap>
                        <Styled.PayCheckTitle>결제가 진행중이에요 잠시만 기다려주세요!</Styled.PayCheckTitle>
                        <Styled.PayCheckText>결제가 진행중이니 잠시만 기다려주세요.<br />화면을 나가게 되면 결제오류가 발생할 수 있어요.</Styled.PayCheckText>
                    </Styled.PayCheckTextWrap>
                </Styled.PayCheckingWrap>
            </Styled.Wrap>
        )
    }

    
}
export default Cart